import { type Member } from "@/features/members/model/members-types";
import { getStatusToneClassName } from "@ibada/ui/lib/status-tone";

export function getStatusBadgeClassName(status: Member["status"]) {
  return getStatusToneClassName(status);
}

export function getInlineStatusTriggerClassName(status: Member["status"]) {
  return getStatusToneClassName(status, "bordered");
}
